/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Card, Flex } from '@radix-ui/themes';

import { use, useCallback, useState } from 'fierry/react';

import Text from 'solis/react/primitive/text';

import ZoneControl from 'solis/claude/section/zone/control';
import ZoneEvents from 'solis/claude/section/zone/events';

import Time from 'solis/time';


const OnSelect = (index, selectedIndex, setSelectedIndex) =>
{
  setSelectedIndex(index === selectedIndex ? null : index);
};


const getSelectedDate = (zoneTimeline, now, index) =>
{
  return zoneTimeline.getFutureEvents(now)[index]?.getDate() ?? null;
};


const useSelection = (zoneTimeline, now) =>
{
  const [ index, setIndex ] = useState(null);

  const onSelect = useCallback(OnSelect, [ index, setIndex ]);

  return [ getSelectedDate(zoneTimeline, now, index), onSelect ];
};


export default (props) =>
{
  const now = use(Time);

  const [ selectedDate, onSelect ] = useSelection(props.zoneTimeline, now);

  const currentDate = selectedDate ?? now;
  const previousDate = selectedDate !== null ? now : null;

  const originalTimeline = props.originalTimeline ?? props.zoneTimeline;

  return (
    <Card>
      <Flex direction = 'column' gap = '3'>

        <Text.Title>{'Zone ' + props.zone.getAbsoluteHex()}</Text.Title>

        <ZoneControl {...props} originalTimeline = {originalTimeline} currentDate = {currentDate} previousDate = {previousDate} />
        <ZoneEvents {...props} originalTimeline = {originalTimeline} currentDate = {currentDate} previousDate = {previousDate} onSelect = {onSelect} />

      </Flex>
    </Card>
  );
};
